import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { Box, Container } from '@mui/material'

import { CustomTitle } from 'src/components/customTitle'
import { Seo } from 'src/components/seo/Seo'

import { AirDucts } from './airDucts'
import { ChimneySystems } from './chimneySystems'

import { getCatalogName } from 'src/utils/parse/catalog'

export const AboutProduct: React.FC = () => {
  const { product } = useParams()
  const title = getCatalogName(product)

  const renderContent = useCallback(() => {
    switch (product) {
      case 'airDucts':
        return <AirDucts />
      case 'chimneySystems':
        return <ChimneySystems />
      default:
        return <AirDucts />
    }
  }, [product])

  return (
    <Box>
      <Container>
        <Seo title={title} canonicalPath={product ? `/about/${product}` : '/about'} />
        <CustomTitle title={title} />
        {renderContent()}
      </Container>
    </Box>
  )
}
